import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

import reportWebVitals from "./reportWebVitals";
import StoreProvider from "./Store/StoreProvider";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import process from "process";
import { GoogleOAuthProvider } from "@react-oauth/google";
// import { ToastProvider } from "@heroui/toast";
// import { ToastProvider } from "@heroui/react";

// Ensure that 'root' exists in the HTML file (usually public/index.html)
const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element not found");
}

window.process = process;
const root = ReactDOM.createRoot(rootElement);

root.render(
  <StoreProvider>
    <GoogleOAuthProvider
      clientId={process.env.REACT_APP_GOOGLE_AUTH_CLIENT_ID || ""}
    >
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </GoogleOAuthProvider>
  </StoreProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
